import { Button } from '@/app/common/components/Button'
import { TeacherIcon } from '@/app/common/icons/general'
import { ProgramSettingsResp } from '@/storage/program_settings/requests'
import { useTranslation } from 'react-i18next'
import AceScholarshipsLogo from '@assets/ACEResized1.png'
import FamilyWizardLayout from '../../family_application/FamilyWizardLayout'
interface Props {
  programSettings: ProgramSettingsResp
  onContinueClick: () => void
}

function ApplicationInformation(props: Props) {
  const { programSettings, onContinueClick } = props
  const { t: translate } = useTranslation()

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Content className="">
        <section aria-labelledby="application-heading">
          <img className="mx-auto mb-10" src={AceScholarshipsLogo} alt={translate('ace_logo')} />
        <FamilyWizardLayout.Header>
          <h1>{programSettings.name}</h1>
        </FamilyWizardLayout.Header>
          <h2
            id="application-heading"
            className="text-xl text-center font-medium text-gray-900 mb-10 sm:mb-5"
          >
            {translate('apply_2025_2026')}
          </h2>

          <div className="space-y-6">
            <section aria-labelledby="what-to-expect">
              <h3 id="what-to-expect" className="flex items-center font-medium">
                <TeacherIcon aria-hidden="true" />
                <span className="ml-2">{translate('what_to_expect')}</span>
              </h3>
              <p className="ml-6 mt-1 text-gray-700 text-sm">
                {translate('fast_and_streamlined')}.
              </p>
            </section>
           {/*  <section aria-labelledby="what-you-will-need">
              <h3
                id="what-you-will-need"
                className="flex items-center font-medium"
              >
                <LightningIcon aria-hidden="true" />
                <span className="ml-2">{translate('what_you_will_need')}</span>
              </h3>
              <ul className="ml-6 mt-1 text-gray-700 text-sm space-y-1">
                <li>{translate('no_additional_documents')}</li>
              </ul>
            </section> */}
          </div>
        </section>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar>
        <Button className="w-full" onClick={onContinueClick}>
          {translate('start_application')}
        </Button>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}

export default ApplicationInformation
